/**
 * Фильтры и пагинация
 * ***/

const $filter = $('.js-filter');

if ($filter.length) {

    /* Кнопки множественного фильтра */
    App.D.on('change', '.js-filter-btn', function (e) {
        const $currFilterBtn = $(this);
        const $filter = $currFilterBtn.closest('.js-filter');
        const $filterAllBtns = $filter.find('.js-filter-btn');
        const $pageInput = $filter.find('.js-page-input');

        if ($currFilterBtn.val() === 'all') {
            $filterAllBtns.prop('checked', false);
            $currFilterBtn.prop('checked', true);
        } else {
            $filterAllBtns.filter('[value="all"]').prop('checked', false);
        }

        $pageInput.val(1);

        loadFilter($filter);

        e.preventDefault();
    });

    /* Кнопка "подрузить еще" */
    App.D.on('click', '.js-more-btn', function (e) {
        const name = $(this).data('name');
        const $filter = $(`.js-filter[data-name="${name}"]`);
        const $pageInput = $filter.find('.js-page-input');

        $pageInput.val(parseInt($pageInput.val()) + 1);
        loadFilter($filter, true);

        e.preventDefault();
    });
}

function loadFilter(filterForm, appendFlag) {
    const filterName = filterForm.data('name');
    const $filterContent = $(`.js-filter-content[data-name="${filterName}"]`);
    let basicUrl = filterForm.data('basic-url') || (location.origin + location.pathname);

    basicUrl = basicUrl.indexOf('?') > 0 ? filterForm.data('basic-url') + '&' : filterForm.data('basic-url') + '?';
    App.H.addClass('_loading');

    $.ajax({
        url: filterForm.attr('action'),
        data: filterForm.serialize(),
        type: filterForm.attr('method') || 'GET',
        cache: false,
        success: (response) => {
            if ($(response).find(`.js-filter-content[data-name="${filterName}"]`).length) {
                const $newContent = $(response).find(`.js-filter-content[data-name="${filterName}"]`);

                // если подгрузка в блок, то добавляем данные в конец блока, иначе обновляем содержимое контента полностью
                if (appendFlag) {
                    $filterContent.append($newContent.html());
                } else {
                    $filterContent.html($newContent.html());
                }

                if (window.history) {
                    history.pushState({param: 'Value'}, '', basicUrl + filterForm.serialize());
                }

                if ($(response).find('.js-more-btn').length) {
                    $('.js-more-btn').show();
                } else {
                    $('.js-more-btn').hide();
                }

                App.H.removeClass('_loading');
            } else {
                console.log('Ошибка получения данных');
            }

            App.H.removeClass('_loading');
        },
        error: () => {
            console.log('Ошибка загрузки отчетов');
            App.H.removeClass('_loading');
        }
    });
}


// WEBPACK FOOTER //
// ./_src/js/FilterAndPagination.js